import axios from 'axios';
import Env from 'Services/Env';
import Store from 'Services/Store';
import CookieStorage from 'Core/commons/CookieStorage';

const QUERY_TIMEOUT = 120000;
class FeedbackService {
    constructor() {
        if (!FeedbackService.instance) {
            this.baseUrl = `${Env.get('sellsyAi')}/feedback`;

            FeedbackService.instance = this;
        }
        return FeedbackService.instance;
    }

    async fetchWithToken(...args) {
        let [resource, config] = args;

        args.signal?.addEventListener('abort', function () {
            return Promise.reject(new DOMException('Aborted', 'AbortError'));
        });

        const feedbackService = new FeedbackService();

        const token = await feedbackService.getAuthorizationToken();
        config = {
            ...config,
            timeout: QUERY_TIMEOUT,
            responseType: 'stream',
            headers: {
                ...config.headers,
                'Content-Type': 'application/json; charset=UTF-8',
                Authorization: token,
            },
        };

        const response = await fetch(resource, config);

        return new Promise((resolve, reject) => {
            if (response.status === 200) {
                resolve(response);
            }

            reject(new Error(response.statusText));
        });
    }

    async create({ uuid, reaction, output, reason = null, feedback = null, type = undefined }) {
        return await this.fetchWithToken(`${this.baseUrl}/create`, {
            method: 'POST',
            body: JSON.stringify({ uuid, reaction, output, reason, feedback, type }),
        });
    }

    /**
     * Get authorization token
     * @returns {Promise<unknown>|Promise<string>}
     */
    async getAuthorizationToken() {
        const currentStaffId = Store.get('user').id;
        const cookieStorage = new CookieStorage('api', 'access_token');
        //Get token in localStorage
        const cached = cookieStorage.get();
        if (cached) {
            const expire = new Date(cached.expireAt).getTime() - 60000; //-60s
            const now = new Date().getTime();
            if (cached.staffId === currentStaffId && expire > now) {
                return Promise.resolve('Bearer ' + cached.token);
            }
        }

        //Get token from saas
        const client = axios.create({
            timeout: QUERY_TIMEOUT,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        return new Promise(function (resolve, reject) {
            client.post('/web-token').then(function (response) {
                if (response.status !== 201 || !response.data.token) {
                    return reject(
                        new Error(
                            window.i18n.gettext("Une erreur d'authentification s'est produite"),
                        ),
                    );
                }

                const cachedData = response.data;
                cachedData.staffId = currentStaffId;
                cookieStorage.set(cachedData);

                return resolve('Bearer ' + response.data.token);
            });
        });
    }
}

export default FeedbackService;
